<template>
    <div>
        <div @click="approvalAuthorityForEdit = (editable ? value : null)" class="aa-container clearfix" :style="{cursor:(editable ? 'pointer' : 'default')}">
            <button type="button" v-if="editable" class="float-right btn btn-link remove" style="height:22px;" :title="translate('approvalAuthorityInfo.removeUserFromStep')" @click.stop="$emit('remove', value)">{{translate('approvalAuthorityInfo.removeUserFromStep')}}</button>
            <user-info v-bind:user="value.User" v-if="value.Kind === 'ApprovalAuthorityUser'"></user-info>
            <div v-else-if="value.Kind === 'ApprovalAuthorityExternal'">
                <div class="float-left"><img class="profile-picture-external" src="../assets/external-user.png"/></div>
                <div class="float-left">
                    <div>{{value.FirstName}} {{value.LastName}}</div>
                    <div><a :href="'mailto:' + value.Email">{{value.Email}}</a></div>
                    <div class="text-muted">{{translate('approvalAuthorityInfo.externalUser')}}</div>
                </div>
            </div>
            <div v-else-if="value.Kind === 'ApprovalAuthorityTitle'">
                <div>{{value.Title.Name}}</div>
            </div>
            <div v-else>
                <div class="text-danger">{{translate('approvalAuthorityInfo.unknownApprovalAuthority')}}: {{value.Kind}}</div>
            </div>
        </div>
        <approval-authority-editor v-if="editable && approvalAuthorityForEdit" @cancel="approvalAuthorityForEdit = null;" @apply="apply" :user-list="userList" v-model="approvalAuthorityForEdit"></approval-authority-editor>
    </div>
</template>

<script>
import userInfo from './UserInfo.vue';
import approvalAuthorityEditor from './ApprovalAuthorityEditor.vue'

export default {
    components: {
        userInfo,
        approvalAuthorityEditor
    },
    props: {
        value: Object,
        userList: Array,
        editable: Boolean
    },
    data: () => {
        return {
            approvalAuthorityForEdit: null
        }
    },
    methods: {
        apply(model) {
            this.$emit('input', model);
            this.approvalAuthorityForEdit = null;
        }
    }
}
</script>

<style scoped>
.aa-container {
    border-radius: 8px;
    padding: 8px;
    margin: 16px 16px 0 16px;
}

.aa-container .remove {
    display:none;
    border: 1px solid red;
    text-align: center;
    width: 150px;
    font-size: 10px;
    text-decoration: none;
    background-image: none;

}

.aa-container:hover {
    background-color: #FFF;
}

.aa-container:hover .remove {
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-picture-external {
    width:42px;
    height:42px;
    border-radius: 8px;
    margin-right: 16px;
}
</style>